// extracted by mini-css-extract-plugin
export var editInput = "_eo-0";
export var editInputCompact = "_eo-2";
export var editInputLarge = "_eo-1";
export var editInputSmall = "_eo-3";